import React from "react";
import ReactDOM from "react-dom";
import ClassListPage from "../components/class/ClassListPage";
import { initializeI18n } from "../localization/i18n";

window.renderClassList = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {
    initializeI18n()
      .then(() => {
        ReactDOM.render(<ClassListPage props={props} />, element);
      })
      .catch(() => {});
  }
};
